import type { CrmNotification } from '../types/crm';

export type NotificationPermissionState = NotificationPermission | 'unsupported';

export function getNotificationPermission(): NotificationPermissionState {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
}

export async function requestNotificationPermission(): Promise<NotificationPermissionState> {
  if (getNotificationPermission() === 'unsupported') return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    return await Notification.requestPermission();
  } catch {
    return Notification.permission;
  }
}

export function showBrowserNotification(
  notification: Pick<CrmNotification, 'id' | 'title' | 'body' | 'link'>,
): void {
  if (getNotificationPermission() !== 'granted') return;

  try {
    const n = new Notification(notification.title, {
      body: notification.body,
      icon: '/icon-192.png',
      badge: '/icon-192.png',
      tag: notification.id,
    });

    n.onclick = () => {
      window.focus();
      n.close();
      if (notification.link) {
        window.location.assign(notification.link);
      }
    };
  } catch {
    // Ignore — some browsers block when tab is focused.
  }
}
